export default __webpack_public_path__ + "static/media/brainspk.37012c0a.jpg";